module.exports = __webpack_public_path__ + "media/images/payments/apple_expiring_in_15_days-55f22b447ff6cb9544833dc64942f95b.png";